<template>
  <div class="p-the-page-l04 c-common-footer-fixed">
    <div class="c-common-footer-fixed__inner">
      <TheHeader ref="theHeader" />
      <div class="c-common-inner">
        <TheBreadcrumb />
        <div class="p-the-page-l04__inner">
          <TheK01Header
            :title="title"
            :published-at="publishedAt"
            :updated-at="updatedAt"
            :author-name="authorName"
            :author-id="authorId"
          />
          <TextSanitized :text="content" class="p-the-page-l04__content" />
        </div>
      </div>
    </div>
    <theFooter />
  </div>
</template>

<script lang="ts">
import TheHeader from "@/common/components/organisms/TheHeader.vue";
import TheFooter from "@/common/components/organisms/TheFooter.vue";
import TheBreadcrumb from "@/common/components/organisms/TheBreadcrumb.vue";
import TextSanitized from "@/common/components/atoms/TextSanitized.vue";
import TheK01Header from "@/general/components/pages/parts/K1Notification/TheK01Header.vue";
import { Options, Vue } from 'vue-class-component';
import {
  getk1NotificationDetails,
  markK1NotificationAsRead
} from "@/general/store/api";
import commons from "@/common/store/modules/commons";
import {
  InformationMessage,
  InformationMessageTrackerRequest
} from "gen/ricapi/api";
import globals from "@/general/store/modules/globals";

import LocalStorage from "@/general/utils/storage";
import AuthStorage from "@/general/utils/auth";

@Options({
  components: {
    TheHeader,
    TheFooter,
    TheBreadcrumb,
    TextSanitized,
    TheK01Header
  }
})
export default class K1Notification extends Vue {
  notification: InformationMessage = {
    title: "",
    updated_at: "",
    created_at: "",
    author_name: "",
    author: 0,
    pk: 0,
    message: "",
    has_read: false,
    page_details: {
      previous: {
        title: "",
        url: ""
      },
      next: {
        title: "",
        url: ""
      }
    },
    start_showing: ""
  };

  breadcrumb = [
    {
      text: "",
      url: "/home",
      pageType: "home"
    },
    {
      text: "お知らせ一覧",
      url: "",
      pageType: "lower"
    }
  ];

  declare $refs: {
    theHeader: TheHeader;
  };

  get title() {
    return this.notification.title;
  }

  get publishedAt() {
    return this.notification.created_at;
  }

  get updatedAt() {
    return this.notification.updated_at;
  }

  get authorName() {
    return this.notification.author_name;
  }

  get authorId() {
    return this.notification.author;
  }

  get content() {
    return this.notification.message;
  }

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }

  mounted() {
    AuthStorage.checkLogin();
  }
  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();
    await commons.setbreadcrumb(this.breadcrumb);
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const id = urlParams.get("id")
      ? parseInt(urlParams.get("id") as string)
      : 1;

    const userDetails = JSON.parse(
      LocalStorage.getItem("userDetails") as string
    );

    this.notification = await getk1NotificationDetails(id);

    const informationMessageTrackerRequest: InformationMessageTrackerRequest = {
      user: userDetails.id,
      message: id,
      has_read: true
    };
    await markK1NotificationAsRead(informationMessageTrackerRequest);
  }
}
</script>

<style lang="scss" scoped>
.p-the-page-l04 {
  &__inner {
    max-width: rem(1110);
    padding: rem(32) 0 rem(56);
    margin: 0 auto;

    @include sp {
      padding: rem(16) 0 rem(48);
    }
  }

  &__content {
    margin-top: rem(24);
    line-height: rem(32);

    @include sp {
      margin-top: rem(8);
    }
  }
}
</style>
